import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "ControlGLReconciliationModeler" })(
  (_theme) => ({
    page: {
      margin: "20px",
    },
    controlGLReconciliationModelerExportBtn: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: "10px",
      marginTop: "-30px",
    },
  }),
);
